export default defineNuxtPlugin(() => {
  try {
    if ('MutationObserver' in window) {
      const updateBodyClass = () => {
        try {
          const modalOpen = document.querySelector('.affirm-sandbox-container')
          document.body.classList.toggle('affirm-modal-open', !!modalOpen)
        } catch (err) {
          console.error('Error updating body class:', err)
        }
      }

      updateBodyClass()

      const observer = new MutationObserver(() => {
        try {
          updateBodyClass()
        } catch (err) {
          console.error('Error in MutationObserver callback:', err)
        }
      })

      observer.observe(document.body, {
        childList: true,
        // subtree: true,
      })

      window.addEventListener('beforeunload', () => {
        try {
          observer.disconnect()
        } catch (err) {
          console.error('Error disconnecting observer:', err)
        }
      })
    }
  } catch (err) {
    console.error('Nuxt plugin initialization error:', err)
  }
})
